export class ChartTPData {
  public constructor (
    readonly year: string,
    readonly month: string,
    readonly name: string,
    readonly sum: string,
  ) {}

  static createListFromResponse (data: any): Array<ChartTPData> {
    return data.map((item: any) => {
      return new ChartTPData(
        item.Jahr,
        item.Monat,
        `${item.ProduktNummer} ${item.ProduktBezeichnung}`,
        item.Sum_Betrag
      )
    })
  }
}
